<template>
<div class="ltr">
  <table class="table">
    <tbody>
      <tr v-for="(link, idx) in links" :key="idx">
        <td>{{ link.content }}</td>
        <td>
          <WhatsAppLink :phoneNumber="applicant.phone_number" :message="link.template" :blocked="!!applicant.blocked" />
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
import WhatsAppLink from '@/components/WhatsAppLink.vue'
import OffersHelper from '@/custom/classes/offers_helper'
import { getOwner } from '@/custom/classes/my_utils.js'

export default {
  name: 'ModalWhatsapp',
  components: {
    WhatsAppLink
  },
  props: {
    applicant: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    const offersHelper = new OffersHelper()
    return {
      links: [
        {
          content: 'יצירת קשר עם מועמד בוואטסאפ',
          template: offersHelper.createFromTemplate('', {})
        },
        {
          content: 'הודעת לינקים למועמד',
          template: offersHelper.createFromTemplate(offersHelper[this.vettingTemplate()], this.vettingParams())
        },
        {
          content: 'הודעה למועמד שעשינו לו השמה',
          template: offersHelper.createFromTemplate(offersHelper[this.vestingTemplate()], this.vestingParams())
        }
      ]
    }
  },
  methods: {
    vestingTemplate () {
      const env = this.$settings.get({ path: 'operation_name' })
      switch (env) {
        case 'Rebase':
          return 'rebaseVestingMessage'
        case 'Piola':
          return 'piolaVestingMessage'
        case 'Bullrun':
          return 'bullrunVestingMessage'
        case 'Suitup':
        default:
          return 'suitupVestingMessage'
      }
    },
    vestingParams () {
      return { admin: getOwner().name, applicant: this.applicant.first_name }
    },
    vettingTemplate () {
      const env = this.$settings.get({ path: 'operation_name' })
      switch (env) {
        case 'Rebase':
          return 'rebaseVettingMessage'
        case 'Piola':
          return 'piolaVettingMessage'
        case 'Suitup':
        default:
          return 'suitupVettingMessage'
      }
    },
    vettingParams () {
      return { admin: getOwner().name, applicant: this.applicant.first_name }
    }
  }
}
</script>
